<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form method="#" action="#" v-on:submit.prevent="handleLogin">
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center">Login</h3>
              </div>
              <div>
                <div class="alert alert-danger" v-if="hasErrors">
                  <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
                  {{errorMessage}}
                </div>
                <fg-input label="Email address or Username"
                          placeholder="Enter email or username"
                          type="text"
                          v-model="model.username">

                </fg-input>
                <fg-input label="passsword"
                          type="password"
                          placeholder="Password"
                          v-model="model.password">
                </fg-input>
                <fg-input>
                  <l-checkbox v-model="model.rememberMe">
                    Remember Me
                  </l-checkbox>
                </fg-input>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-fill btn-success btn-round btn-wd">Login</button>
              </div>
            </card>
          </fade-render-transition>

        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import { Checkbox as LCheckbox, FadeRenderTransition } from "../../components/index";
import AuthLayout from "../Layouts/AuthLayout.vue";

export default {
  components: {
    LCheckbox,
    FadeRenderTransition,
    AuthLayout
  },
  data() {
    return {
      model: {
        username: "",
        password: "",
        rememberMe: false
      },
      hasErrors: false,
      errorMessage: ""
    };
  },
  methods: {
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    handleLogin() {
      this.hasErrors = false;

      this.$auth
        .login({
          data: this.model,
          rememberMe: this.model.rememberMe,
          redirect: "/"
        })
        .catch((error) => {
          this.hasErrors = true;
          if (error.response) {
            this.errorMessage = error.response.data.message;
          } else {
            this.errorMessage = error;
          }
        });
    }
  },
  beforeDestroy() {
    this.closeMenu();
  }
};
</script>
<style scoped lang="scss">
  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }
</style>
